import { render, staticRenderFns } from "./manpowermenubar_govem.vue?vue&type=template&id=21ccb6aa&"
import script from "./manpowermenubar_govem.vue?vue&type=script&lang=js&"
export * from "./manpowermenubar_govem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports